// @ts-nocheck
/* eslint-enable */
// App
import React from 'react';
import { useSelector } from 'react-redux';

// Hooks

import { useMarketingBlurb } from './useMarketingBlurb';

// Misc / utils
import * as S from './styles';

const MarketingBlurb = () => {
  // Redux
  const areaName = useSelector((state) => state.area.area.name);
  const propertyTypes = useSelector((state) => state.filter.propertyTypes);
  const isHouse =
    propertyTypes.house === true &&
    propertyTypes.any === false &&
    propertyTypes.apartment === false &&
    propertyTypes.condo === false &&
    propertyTypes.duplex === false &&
    propertyTypes.townhouse === false;

  // Hooks
  const [dynamicBlurb, blurbLinks, houseOrApartment] = useMarketingBlurb();

  return (
    <>
      <S.BlurbParagraph>
        Searching for {houseOrApartment}s to rent in {areaName} is easy when you utilize HotPads map-based search
        platform. {dynamicBlurb} We make it easy with our one-click contact form so you can quickly send your next
        inquiry.
      </S.BlurbParagraph>
      <S.BlurbParagraph>
        We know {houseOrApartment} hunting is personal and everyone has different needs so let HotPads do the heavy
        lifting by setting your specific filters that include bedroom and bathroom counts, price range, square footage,
        and many more. Looking for {blurbLinks.petFriendly} rentals or places with{' '}
        {isHouse ? 'in-unit laundry' : blurbLinks.withInUnitLaundry}? Just specify in your filters. Or have a tight
        deadline and need to move before a certain date? Search by availability dates. Want to keep up on the latest
        rentals available in {areaName}? Save your search filters with the “Get Alerts” button to receive the freshest{' '}
        {houseOrApartment} recommendations as they come on-market.
      </S.BlurbParagraph>
      <S.BlurbParagraph>
        {isHouse ? (
          'If '
        ) : (
          <>
            Look out for {houseOrApartment} rentals with highlighted amenities such as {blurbLinks.withGym} and{' '}
            {blurbLinks.withParking}. Or if{' '}
          </>
        )}
        you’re looking for a deal, find listings that have had ‘Price Drops’ and watch for listings with a{' '}
        {blurbLinks.withPromo} by searching “Promos” within the filters. We’ve also made it easy to find that perfect{' '}
        {blurbLinks.luxuryPads} or affordable rentals by visiting our {blurbLinks.affordablePads}.
      </S.BlurbParagraph>
    </>
  );
};

export default MarketingBlurb;
